const baseURL = '/api/message/'

export default baseURL
